const TOPICS = ["AI", "Chips", "Startups", "Gadgets", "Cloud", "Security", "Space", "Open Source"];

export const Marquee = () => (
  <div data-testid="topics-marquee" className="overflow-hidden border-y border-[var(--line)] py-5 mb-20">
    <div className="marquee flex w-max gap-12 whitespace-nowrap font-display text-2xl md:text-3xl italic text-[var(--smoke)]">
      {[...TOPICS, ...TOPICS].map((t, i) => (
        <span key={i} className="flex items-center gap-12">
          {t}<span className="h-1.5 w-1.5 rounded-full bg-[var(--ember)]" />
        </span>
      ))}
    </div>
  </div>
);

export const Footer = () => (
  <footer data-testid="site-footer" className="flex flex-col md:flex-row justify-between gap-4 px-6 md:px-12 lg:px-20 py-10 border-t border-[var(--line)] font-mono text-[11px] uppercase tracking-[0.2em] text-[var(--smoke)]">
    <span>© {new Date().getFullYear()} HostNode</span>
    <span>Trending tech news · hostnode.cloud</span>
  </footer>
);
